import styled from 'styled-components'

import Bg from '~/shared/assets/background/corporate-guide.png'
import theme from '~/shared/styles/theme'

function GuideSection() {
  return (
    <Wrapper>
      <Image src={Bg} alt="" />
    </Wrapper>
  )
}

export default GuideSection

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;

  @media ${theme.device.medium} {
    gap: 24px;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
`
